import { Text } from '@chakra-ui/react';

import { useUnits, usePaginateUnits } from 'hooks/units';
import { useFilters } from 'hooks/filters';

import AsyncTable from 'components/Tables/AsyncTable';
import StatusIndicator from 'components/StatusIndicator';
import dateFormat from 'functions/dateFormat';
import { useEffect } from 'react';

const columns = [
	{
		Header: 'Nome',
		accessor: 'name'
	},
	{
		Header: 'Beneficiários Ativos',
		accessor: 'beneficiaries_count'
	},
	{
		Header: 'Status',
		accessor: 'is_active',
		Cell: ({ value }) => <StatusIndicator isActive={value} size="sm" />
	},
	{
		Header: 'Regional',
		accessor: 'regional.name'
	},
	{
		Header: 'Data de criação',
		accessor: 'created_at',
		Cell: ({ value }) => <Text>{dateFormat(value)}</Text>
	}
];

const UnitsTable = () => {
	const { filters } = useFilters();
	const { rows, page, perPage, total, setToDelete, setDeleteModalOpen } =
		useUnits();
	const [paginateUnits, { loading }] = usePaginateUnits();

	const deleteUnit = (id) => {
		setToDelete(id);
		setDeleteModalOpen(true);
	};

	const fetchData = ({ pageSize, pageIndex }) => {
		if (pageSize != perPage) pageIndex = 1;
		paginateUnits({
			variables: {
				first: pageSize || perPage,
				page: pageIndex || page,
				...filters
			}
		});
	};

	useEffect(() => {
		if (filters && Object.keys(filters).length > 0) {
			paginateUnits({
				variables: {
					first: perPage,
					page,
					...filters
				}
			});
		}
	}, [filters]);

	return (
		<AsyncTable
			fetchData={fetchData}
			isLoaded={!loading}
			data={!loading ? rows : [{}, {}, {}, {}]}
			columns={columns}
			total={total}
			size={perPage}
			asyncPage={page}
			searchByName
			baseRoute="unidades"
			removeAction={deleteUnit}
			linkRow
		/>
	);
};

export default UnitsTable;
